
import { autoinject } from 'aurelia-dependency-injection';
import { BaseModal } from '../../../../../models/basics/basics.models';
import { GenericConfirmationDialogModel } from '../../../../../models/basics/generic-confirmation-dialog-model';
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";

@autoinject
export class CaConfirmationDialog extends BaseModal {

    dataModel: GenericConfirmationDialogModel;

    constructor(dialogClient: DialogClientService) {
        super(dialogClient);
    }

    activate(dataModel: GenericConfirmationDialogModel) {
        this.dataModel = dataModel;
    }
    
    protected getKey() : string {
        return this.dataModel.dialogKey;
    }

    onCancel(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.runCallback(this.dataModel.onCancel, resolve, reject);
        });
    }

    onConfirm(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.runCallback(this.dataModel.onConfirm, resolve, reject);
        });
    }

    private runCallback(callback: () => void | Promise<any>, resolve: (value?: void | PromiseLike<void>) => void, reject: (reason?: any) => void) {
        if (callback) {
            const response = callback();
            if (response instanceof Promise) {
                response.then(() => {
                    this.hideModal(resolve);
                }).catch(() => {
                    reject();
                });
            }
            else {
                this.hideModal(resolve);
            }
        } else {
            this.hideModal(resolve);
        }
    }
}
